<template>
  <div>
    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-select v-if="theUserProject==0" v-model='theProjectId' @change="theProjectAllChange" size="small" clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data||[]" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
        <el-select v-model='theclType' @change="theclTypeChange" size="small" clearable placeholder="请选择类型">
          <el-option :value="1" label="开单"></el-option>
          <el-option :value="2" label="日报"></el-option>
          <el-option :value="3" label="周报"></el-option>
          <el-option :value="4" label="月报"></el-option>
        </el-select>
        <el-input v-model="getCircleLetterList_data.clTitle" placeholder="请输入帖子标题" clearable size='small'
          style="max-width:200px;" />
        <el-input v-model="getCircleLetterList_data.clContext" placeholder="请输入帖子内容" clearable size='small'
          style="max-width:200px;" />
        <el-input v-model="getCircleLetterList_data.userName" placeholder="请输入发布者" clearable size='small'
          style="max-width:200px;" />
        <el-button v-click.getCircleLetterList type="primary" icon='el-icon-search' size='small'
          style='margin-left:10px;'>搜索
        </el-button>
      
      </el-col>
      <el-col :span="6">
        <el-dropdown size='small' v-if="theclType == 1 && exportCircleLetterOrder" split-button type="warning" style="margin-left: 10px;width: 30%;" @click="Out()"
          @command="Out">
          导出
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item style="background-color: #E6A23C;color: white;" command="1">导出全部</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-row>

    <mytable ref="getCircleLetterListTable" :tableColums='tableColums_getCircleLetterList' api='getCircleLetterList::clId' updateapi='updateCircleLetter'
      :height="H-165">
      <div slot="clTitle" slot-scope="{row}" style="max-height: 20vh;overflow: hidden;max-width: 99%;">
        <div v-if="row.clType == 1">
          {{row.clTitle.departmentCity+':'+row.clTitle.numCity
					+row.clTitle.department + ':'+row.clTitle.num
           +'单位: '+ row.clTitle.customName  + '  金额: '+row.clTitle.ouMoney}} 
        </div>
        <div v-else>
          {{row.clTitle}}
        </div>
      </div>
      <div slot="clContent" slot-scope="{row}" style="max-height: 20vh;overflow: hidden;max-width: 99%;">
        <div v-if="row.clType == 1">
          <div v-for="(item,index) in row.clContent" :key="index">
            <div style="width: 100%;height: 100%;display: flex;align-items: center;" v-if="!item.ycbaName">
              <div style="text-align: right;width: 50%;">
                <div>签约数量:</div>
                <div>签约年限:</div>
                <div>签约金额:</div>
                <div>签约产品:</div>
              </div>
              <div style="text-align: left;width: 50%;margin-left: 1rem;">
                <div>{{item.ouBusinessNum}}</div>
                <div>{{item.obYear}}</div>
                <div>{{item.obMoneyYear}}</div>
                <div>{{item.businessName}}</div>
              </div>
            </div>
            <div style="width: 100%;display: flex;justify-content: center;" v-else>
              <div style="width: 48%;text-align: right;">
                {{item.ycbaName}}:
              </div>
              <div style="width: 50%;">{{item.ycbaValue}}</div>
            </div>

          </div>
        </div>
        <div v-else>
          <el-popover placement="top-start" title="内容详情" width="800" trigger="click" content="">
            <el-table :data="row.clContent" height="400" style="width: 100%;">
              <el-table-column width="150" prop="userName" label="用户"></el-table-column>
              <el-table-column prop="name" label="战队">
                <template slot-scope="scope">
                  <div>{{scope.row.department.dtName}}</div>
                </template>
              </el-table-column>
              <el-table-column width="300" prop="userAccount" label="手机号"></el-table-column>
              <el-table-column prop="userVisitorCount" label="走访数量"></el-table-column>
              <el-table-column prop="userOrderNum" label="订单总数"></el-table-column>
              <el-table-column prop="" label="总业绩"></el-table-column>

            </el-table>
            <el-button slot="reference" size="mini" type="text" style="color:#409EFF ;">点击预览</el-button>

          </el-popover>
        </div>
      </div>
    </mytable>
  </div>
</template>

<script>
import qs from 'qs';
import axios from 'axios';
  export default {
    data() {
      return {
        baseUrl: $Api.baseUrl_online,
        theclType: null,
        csAttrId: null,
        theProjectId: "",
        theUserProject: "",
        tableColums_getCircleLetterList: {
          $selection: true,

          userName: '发布者',

          clTitle: '标题',

          clContent: '内容',

          // clHtml: '富文本内容',

          createtime: '创建时间',


        },

      };
    },

    watch: {

    },

    methods: {
      Out(e){
        var that = this
        if (e) {
          const bulkdata = {
          projectId: that.theProjectId,      
          exportType: 1,       
        }
        this.openLoading();
        var s = qs.stringify(bulkdata);
        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/circle-letter/exportCircleLetterOrder',
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: 'arraybuffer',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function (res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/zip"
            });
            console.log(blob);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '喜报.zip');
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
            // that.BulkClose()
          }
        })
        }else{
          const selection = Object.keys(this.$refs.getCircleLetterListTable.$MyTableCache);
          if (selection.length === 0) return alertWarn('请选择您要导出的数据！');
          console.log(selection);
          const bulkdata = {
          projectId: that.theProjectId,      
          exportType: 2,
          clIds: selection.join()
        }
        this.openLoading();
        var s = qs.stringify(bulkdata);

        axios({
          method: 'post',
          url: that.baseUrl + '/opportunity/circle-letter/exportCircleLetterOrder',
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: 'blob',
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            'token': A.local('$Usertoken'),
            'projectId': +A.local('$projectId'),
          }
        }).then(function (res) {
          if (res.data) {
            that.loading.close();
            let a = document.createElement('a');
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/zip"
            });
            console.log(blob);
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", '喜报');
            a.click();
            that.$message({
              message: "成功",
              type: "success"
            });
            // that.BulkClose()
          }
        })
        }
      },
      openLoading() {
      //loading请求等待
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
      theclTypeChange(e) {
        this.theclType = e;
        this.getCircleLetterList({
          projectId: this.theProjectId,
          clType: this.theclType,
          cmId: 2
        }).result(res => {
          res.data.data.forEach((item, index) => {
            if (item.clType == 1) {
              item.clTitle = JSON.parse(item.clTitle)
            }
            item.clContent = JSON.parse(item.clContent)

          })
        });
      },
      theProjectAllChange(e) {
        this.theProjectId = e;
        this.getCircleLetterList({
          projectId: this.theProjectId,
          cmId: 2
        }).result(res => {
          res.data.data.forEach((item, index) => {
            if (item.clType == 1) {
              item.clTitle = JSON.parse(item.clTitle)
            }
            item.clContent = JSON.parse(item.clContent)


          })
        });;
      },
    },

    created() {
      this.theUserProject = A.local('$projectId');
      if (this.theUserProject == 0) {
        this.getProjectList({
          pageSize: 0
        });
      } else {
        this.theProjectId = this.theUserProject;
      }
      this.getCircleLetterList({
        projectId: this.theProjectId,
        cmId: 2
      }).result(res => {
        res.data.data.forEach((item, index) => {
          if (item.clType == 1) {
            item.clTitle = JSON.parse(item.clTitle)
          }
          item.clContent = JSON.parse(item.clContent)


        })
      });
    },
    mounted() {

    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/discoveries/MomentsManage.vue